import { useQuery } from '@tanstack/react-query'
import { fetchCohortsByNation } from '@/services/cohorts'

export function useCohortsByNation(nationId: string | undefined) {
  const cohortsQuery = useQuery({
    queryKey: ['cohorts', 'nation', nationId],
    queryFn: () => fetchCohortsByNation(nationId!),
    enabled: !!nationId,
  })

  return {
    cohorts: cohortsQuery.data,
    isLoading: cohortsQuery.isLoading,
    error: cohortsQuery.error,
  }
}
